import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import globeIcon from '../assets/globe.png';
import arrowIcon from '../assets/arrow.svg';
import primusLogo from '../assets/primuslogo-noback.png';
import { useLanguage } from '../hooks/useLanguage';

interface HeaderProps {
  onConsultingHover: (isOpen: boolean) => void;
  isDropdownOpen: boolean;
}

const Header: React.FC<HeaderProps> = ({ onConsultingHover, isDropdownOpen }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { language, setLanguage, t } = useLanguage();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
        <nav className="navbar">
          <Link to="/" className="logo-link">
            <img src={primusLogo} alt="Primus Logo" className="logo-image" />
          </Link>
          <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <div 
              className={`nav-item-dropdown ${isDropdownOpen ? 'dropdown-open' : ''}`}
              onMouseEnter={() => onConsultingHover(true)}
            >
              <a href="#consulting" className="nav-link">
                Consulting
                <img src={arrowIcon} alt="Arrow" className="dropdown-arrow" />
              </a>
            </div>
            <Link to="/passion-project" className="nav-link">{language === 'en' ? <><em>Mens et Manus</em> - Passion Project</> : 'Mens et Manus-열정 프로젝트'}</Link>
            <Link to="/philosophy" className="nav-link">{t('nav.philosophy')}</Link>
            <Link to="/team" className="nav-link">{t('nav.team')}</Link>
            <Link to="/contact" className="nav-link">{t('nav.contact')}</Link>
          </div>
          
          <div className="language-switcher">
            <img src={globeIcon} alt="Language" className="globe-icon" />
            <button 
              onClick={() => setLanguage('en')} 
              className={`language-btn ${language === 'en' ? 'active' : ''}`}
            >
              EN
            </button>
            <span className="language-divider">|</span>
            <button 
              onClick={() => setLanguage('ko')} 
              className={`language-btn ${language === 'ko' ? 'active' : ''}`}
            >
              한
            </button>
          </div>
          
          <div className="hamburger" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </nav>
    </header>
  );
};

export default Header;